const main_color_rgba = (opacity) => `rgba(114, 143, 129, ${opacity})`;

const addOpacityTo = (hex, opacity) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default {
  dark_background: '#413e3e',
  main_color: '#728F81',
  main_color_rgba,
  main_color_gradient: `linear-gradient(to top, ${main_color_rgba(0.1)}, ${main_color_rgba(1)})`,
  text_color: '#FFFFFF',
  text_color_disabled: '#cecece',
  error_color: '#ff6262',
  addOpacityTo,
};
